import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Project } from '../models/Project';

export class ProjectMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Project {
    return new Project(data.id, this.gqlIdEncoder.decode(data.id), data.name);
  }
}
